import { render, staticRenderFns } from "./ScreenWrapper.vue?vue&type=template&id=12fa0658&scoped=true"
import script from "./ScreenWrapper.vue?vue&type=script&lang=js"
export * from "./ScreenWrapper.vue?vue&type=script&lang=js"
import style0 from "./ScreenWrapper.vue?vue&type=style&index=0&id=12fa0658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa0658",
  null
  
)

export default component.exports